import React, { useState, useEffect } from "react";
import { StyleSheet, Text, TextInput, View } from "react-native";
import CheckIcon from "@assets/svg/CheckGreen";
import ErrorIcon from "@assets/svg/Error";
import colors from "@constants/color";
import Photo from "./Photo";
import Comment from "./Comment";
import { saveJsonData, removeJson } from "../../utils/commonFunctions";

import t from "@constants/localization";

const PATH = "screens/KYCSetup/PanSection";

const PAN_NUMBER_REGEX = /[A-Z]{5}[0-9]{4}[A-Z]{1}/;

const PANSection = (props) => {
  const {
    panNumber,
    setPanNumber,
    panPhoto,
    uploadPanPhoto,
    removePanPhoto,
    disablePanSection,
    verified,
    rejectionComment = null,
    testPANid = "",
  } = props;
  const [unmatched, setUnmatched] = useState(false);
  const { source } = panPhoto;

  const _onBlur = () => {
    if (panNumber && panNumber.length) {
      if (PAN_NUMBER_REGEX.test(panNumber)) {
        saveJsonData("kyc_pan_number", panNumber);
      } else {
        setUnmatched(true);
        removeJson("kyc_pan_number");
      }
    }
  };

  const _onChangeText = (text) => {
    setUnmatched(false);
    setPanNumber(text);
  };

  const title = `PAN ${verified ? t(`${PATH}/PANVerified`) : ""}`;
  return (
    <View style={styles.panContainer}>
      <Comment kycComment={rejectionComment} />
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        {verified && (
          <CheckIcon
            fill="rgba(0,171,89,1)"
            size={20}
            style={{ marginRight: 5 }}
          />
        )}
        <Text> {title} </Text>
      </View>
      <View style={[styles.textInputWrapper, { position: "relative" }]}>
        <TextInput
          testID={testPANid}
          editable={!disablePanSection}
          style={[
            styles.textInput,
            { borderColor: unmatched ? colors.primary : "rgba(0,0,0,0.2)" },
            {
              backgroundColor: disablePanSection ? "rgba(0,0,0,0.05)" : "white",
            },
          ]}
          autoCapitalize="characters"
          placeholder="ALWPG5809L"
          onChangeText={_onChangeText}
          onBlur={_onBlur}
          value={panNumber}
          maxLength={10}
        />

        {unmatched && (
          <View
            style={{
              position: "absolute",
              right: 0,
              flexDirection: "row",
              height: "100%",
              alignItems: "center",
              paddingRight: 10,
            }}
          >
            <ErrorIcon />
            <Text
              style={{ fontSize: 12, color: colors.primary, marginLeft: 4 }}
            >
              {t(`${PATH}/checkPAN`)}
            </Text>
          </View>
        )}
      </View>
      <View style={{ alignSelf: "flex-start" }}>
        <Photo
          ctaText={t(`${PATH}/uploadPhoto`)}
          onUpload={uploadPanPhoto}
          onDelete={removePanPhoto}
          source={source}
          disabled={disablePanSection}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  textInputWrapper: {
    marginTop: 5,
    marginBottom: 10,
  },
  textInput: {
    paddingVertical: 9,
    paddingHorizontal: 15,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: "rgba(0,0,0,0.2)",
    color: "black",
  },
  panContainer: {
    marginTop: 30,
  },
});

export default PANSection;
